/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { useMutation, useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { globalEnv } from '../../../config/baseConfig';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import { BackgroundImage } from '../../SubSections/Topic/imageComponents/imageComponent';
import StyleModalContent from '../../SubSections/Topic/TopicStyling/styleModal';
import { DataNotFoundAnimation } from '../../Utils/ErrorAnimations/dataNotFoundAnim';
import LoadingAnimComponent from '../../Utils/LoadingAnimations/loadingAnimation';
import LoadingRectanglesAnimation from '../../Utils/LoadingAnimations/LoadingRectanglesAnimation';
import { stateNotificationsEnum } from '../../Utils/notification';
import SaveButton from '../../Utils/saveButton';
import ParentModal from '../../Utils/Components/parentModal';
import { axiosInstance } from '../../../config/axiosInstance';
import EditImageModalContent from './editImageModalContent';
import { ClockTypes } from '../../SubSections/Topic/TopicStyling/StyleComponents/mixins/optionsValues';
import {
	BasicTopicStyle,
	TopicStyles
} from '../../SubSections/Topic/TopicStyling/StyleComponents/mixins/mixins';

export default function EditCreatedTopic() {
	const [topicId, setId] = useState('');
	const [name, setName] = useState('');
	const [description, setDescription] = useState('');
	const [code, setCode] = useState('');
	const [tags, setTags] = useState<string[]>([]);

	const [images, setImages] = useState<any[]>([]);
	const [videos, setVideos] = useState<any[]>([]);

	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);

	const [isEditImageModalOpen, setEditImageModalOpen] = useState(false);
	const [isEditImageModalChanged, setIsEditImageModalChanged] = useState(false);

	const [imageId, setEditImageModalId] = useState('');
	const [isPrivate, setIsPrivate] = useState(false);
	const [style, setStyle] = useState<TopicStyles>(BasicTopicStyle);

	const [isStyleModalOpen, setIsStyleModalOpen] = useState(false);
	const [isStyleModalChanged, setIsStyleModalChanged] = useState(false);

	const [isSaving, setIsSaving] = useState(false);

	const [reviewStatus, setReviewStatus] = useState('pending');
	const [featuredStatus, setFeaturedStatus] = useState('none');

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const { id } = useParams();

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const { isError, data, isFetching, isLoading } = useQuery(
		['topics', topicId],
		() => fetchTopicDetails(id!),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 0,
			cacheTime: 0
		}
	);

	async function fetchTopicDetails(id: string) {
		console.log('isFetch ' + id);
		const { data } = await axiosInstance.get(
			`${globalEnv.BASE_URL}/admin/topic/${id}/get-topic-full`,
			{
				headers: {
					Authorization: 'Bearer ' + ACCESS_TOKEN
				}
			}
		);
		return data;
	}

	useEffect(() => {
		if (data != null) {
			setId(data._id);
			setName(data.name);
			// setDailyImage(data.dailyImage.url);
			setImages(data.backgroundImages);
			setVideos(data.videos);
			setIsPrivate(data.isPrivate);
			setName(data.name);
			setDescription(data.description);
			setCode(data.code);
			setTags(data.tags);
			if (data.reviewStatus != null) setReviewStatus(data.reviewStatus);
			else setReviewStatus('pending');
			if (data.featuredStatus != null) setFeaturedStatus(data.featuredStatus);
			else setFeaturedStatus('none');

			if (data.newStyle != null) {
				let clock;
				try {
					if (data.newStyle.clock.kind === ClockTypes.Analog)
						clock = {
							kind: data.newStyle.clock.kind,
							showSeconds: data.newStyle.clock.showSeconds,
							size: data.newStyle.clock.size,
							isDark: data.newStyle.clock.isDark,
							isNumbered: data.newStyle.clock.isNumbered
						};
					else if (data.newStyle.clock.kind === ClockTypes.Digital)
						clock = {
							kind: data.newStyle.clock.kind,
							showSeconds: data.newStyle.clock.showSeconds,
							size: data.newStyle.clock.size,
							boldness: data.newStyle.clock.boldness,
							showAmPm: data.newStyle.clock.showAmPm,
							showTwentyFour: data.newStyle.clock.showTwentyFour
						};
					else
						clock = {
							kind: data.newStyle.clock.kind,
							size: data.newStyle.clock.size,
							boldness: data.newStyle.clock.boldness
						};
				} catch (e) {
					clock = BasicTopicStyle.clock;
				}

				try {
					let defaultBookmarkList;
					if (data.defaultBookmarkList != null)
						defaultBookmarkList = data.defaultBookmarkList;
					else defaultBookmarkList = BasicTopicStyle.defaultBookmarkList;

					setStyle({
						appearanceStyle: {
							font: data.newStyle.appearanceStyle.font,
							mode: data.newStyle.appearanceStyle.mode,
							opacity: data.newStyle.appearanceStyle.opacity,
							view: data.newStyle.appearanceStyle.view
						},
						quoteStyle: {
							size: data.newStyle.quoteStyle.size,
							useCustomQuote: data.newStyle.quoteStyle.useCustomQuote,
							customQuote:
								data.newStyle.quoteStyle.customQuote != null
									? data.newStyle.quoteStyle.customQuote
									: null
						},
						sidebarStyle: {
							contentWidth: data.newStyle.sidebarStyle.contentWidth,
							width: data.newStyle.sidebarStyle.width,
							view: data.newStyle.sidebarStyle.view
						},
						wallpaperStyle: {
							background: data.newStyle.wallpaperStyle.background,
							blur: data.newStyle.wallpaperStyle.blur,
							brightness: data.newStyle.wallpaperStyle.brightness
						},
						searchbarOptions: data.newStyle.searchbarOptions,
						searchEngines: data.newStyle.searchEngines,
						focusStyle:
							data.newStyle.focusStyle != null
								? {
										myFocus: data.newStyle.focusStyle.myFocus,
										size: data.newStyle.focusStyle.size
								  }
								: BasicTopicStyle.focusStyle,
						greetingStyle:
							data.newStyle.greetingStyle != null
								? { size: data.newStyle.greetingStyle.size }
								: BasicTopicStyle.greetingStyle,
						clock: clock,
						featuresStyle: {
							time: data.newStyle.featuresStyle.time,
							date: data.newStyle.featuresStyle.date,
							weather: data.newStyle.featuresStyle.weather,
							bookmarks: data.newStyle.featuresStyle.bookmarks,
							notes: data.newStyle.featuresStyle.notes,
							quote: data.newStyle.featuresStyle.quote,
							integrations: data.newStyle.featuresStyle.integrations,
							searchBar: data.newStyle.featuresStyle.searchBar
						},
						integrationsStyle: data.newStyle.integrationsStyle,
						bookmarkStyle: {
							selectedBookmarks: data.newStyle.bookmarkStyle.selectedBookmarks,
							blackAndWhite: data.newStyle.bookmarkStyle.blackAndWhite,
							openNewTab: data.newStyle.bookmarkStyle.openNewTab,
							square: data.newStyle.bookmarkStyle.square,
							gap: data.newStyle.bookmarkStyle.gap,
							size: data.newStyle.bookmarkStyle.size
						},
						defaultBookmarkList: defaultBookmarkList
					});
				} catch (e) {
					console.log(e);
				}
			}
		}
	}, [data]);

	useEffect(() => {
		return () => {
			console.log('Unmount!');
		};
	}, []);

	const saveTopicReq = async () => {
		const dto = {
			topicId: topicId,
			name: name,
			description: description,
			code: code,
			tags: tags,
			newStyle: style,
			isPrivate: isPrivate,
			defaultBookmarkList: style.defaultBookmarkList,
			reviewStatus: 'pending',
			featuredStatus: 'none'
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance.put(
			globalEnv.BASE_URL + '/admin/topic/update',
			dto,
			config
		);
		return response;
	};

	const dispatch = useDispatch();
	const saveTopic = useMutation(saveTopicReq, {
		onMutate: () => setIsSaving(true),
		onSuccess: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated topic info.'
				})
			);
			navigate('../documents');
		},
		onError: () => {
			setIsSaving(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update topic info."
				})
			);
		}
	});

	const navigate = useNavigate();

	return (
		<div className="w-full h-screen">
			<Scrollbars autoHide>
				{isLoading ? (
					<div>
						<LoadingAnimComponent />
					</div>
				) : isError ? (
					<div className="h-full">
						<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
							<div className="mx-auto my-auto self-center">
								<div className="min-h-16">
									<DataNotFoundAnimation height={dimensions.height / 1.5} />
								</div>
								<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
									{"Couldn't find the data you're looking for!"}
								</h3>
							</div>
						</div>
					</div>
				) : (
					<main className="pt-16 h-full ">
						<div className="h-16 fixed z-20 w-full dark:bg-gray-800 bg-white px-6 md:px-30 lg:px-40 transition-all duration-500">
							<div className="flex flex-row  ml-16 mt-4">
								<span className="text-xl font-bold block uppercase tracking-wide text-oldgray-600 dark:text-white transition-all duration-500">
									{images != null && images.length}{' '}
									{images.length > 1 ? 'Images' : 'Image'}
								</span>

								<ParentModal
									visible={isStyleModalOpen}
									setModalOpen={setIsStyleModalOpen}
									isWarnModalOpen={isWarnModalOpen}
									setIsWarnModalOpen={setIsWarnModalOpen}
									isChanged={isStyleModalChanged}
									setIsChanged={setIsStyleModalChanged}
								>
									<StyleModalContent
										style={style}
										setStyle={setStyle}
										setModalOpen={setIsStyleModalOpen}
										isWarnModalOpen={isWarnModalOpen}
										setIsWarnModalOpen={setIsWarnModalOpen}
										isChanged={isStyleModalChanged}
										setIsChanged={setIsStyleModalChanged}
									/>
								</ParentModal>

								<button
									type="button"
									className="btn btn-outline btn-sm btn-primary ml-auto mr-2"
									onClick={() => setIsStyleModalOpen(true)}
								>
									Stylize
								</button>

								<button
									className={`btn btn-outline btn-sm btn-primary mr-3 ${
										isPrivate || 'btn-accent'
									}`}
									type="button"
									style={{ transition: 'all .15s ease' }}
									onClick={() => {
										setIsPrivate(!isPrivate);
									}}
								>
									{isPrivate ? 'Private' : 'Public'}
								</button>

								<SaveButton
									text="Finish"
									isSaving={isSaving}
									saveFunc={() => saveTopic.mutate()}
								/>
							</div>
						</div>
						<section className="">
							<div className="mt-7">
								<div className="relative flex flex-col">
									<div className="px-6">
										<div className="text-center">
											<div className="text-gray-500 font-bold mx-auto ml-18 mt-4">
												<div className="container sm:px-2 md:px-20 mx-auto lg:px-32 text-center mb-4">
													<div className="flex flex-row mb-3">
														<ParentModal
															visible={isEditImageModalOpen}
															setModalOpen={setEditImageModalOpen}
															isWarnModalOpen={isWarnModalOpen}
															setIsWarnModalOpen={setIsWarnModalOpen}
															isChanged={isEditImageModalChanged}
															setIsChanged={setIsEditImageModalChanged}
														>
															<EditImageModalContent
																setModalOpen={setEditImageModalOpen}
																topicId={topicId}
																imageId={imageId}
																images={images}
																setImages={setImages}
																isWarnModalOpen={isWarnModalOpen}
																setIsWarnModalOpen={setIsWarnModalOpen}
																isChanged={isEditImageModalChanged}
																setIsChanged={setIsEditImageModalChanged}
															/>
														</ParentModal>
													</div>

													{isFetching || isLoading ? (
														<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 justify-items-center gap-4 mt-5">
															<LoadingRectanglesAnimation />
														</div>
													) : isError ? (
														<></>
													) : (
														<div className="flex flex-wrap -m-1 md:-m-2">
															{images != null &&
																images.map((item: any) => {
																	return (
																		<BackgroundImage
																			key={item._id}
																			item={item}
																			topicId={topicId}
																			images={images}
																			setImages={setImages}
																			setEditImageModalOpen={
																				setEditImageModalOpen
																			}
																			isMine={true}
																			reloadCount={0}
																			setReloadCount={() => {
																				return;
																			}}
																			setEditImageModalId={setEditImageModalId}
																			isForPhone={false}
																			setCoverPic={() => {
																				return;
																			}}
																			setIsChanged={() => {
																				return;
																			}}
																		/>
																	);
																})}
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</main>
				)}
			</Scrollbars>
		</div>
	);
}
